/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPennant2 = createReactComponent("outline", "pennant-2", "IconPennant2", [["path", { "d": "M16 21h-4", "key": "svg-0" }], ["path", { "d": "M14 21v-18", "key": "svg-1" }], ["path", { "d": "M14 4l-9 4l9 4", "key": "svg-2" }]]);

export { IconPennant2 as default };
//# sourceMappingURL=IconPennant2.mjs.map
